// extracted by mini-css-extract-plugin
export default {"card":"ViewReport_card__m6WkB"};